import type { RootState } from '@oneview/redux/rootReducer';
import { createSelector } from '@reduxjs/toolkit';

export const selectTabBar = (state: RootState) => state.tabBar;

export const selectOpeningTabs = createSelector(selectTabBar, (tabBar) => tabBar.tabs);

export const selectActiveTab = createSelector(selectTabBar, (tabBar) => tabBar.tabs[tabBar.activeTabIndex]!);
